export default "__VITE_ASSET__BUwOEzMC__"